import { VideoStatus, getVideoStatusViaString } from './VideoStatus';
import { SportSkill } from './SportSkill';

/**
 * Video class - Simplified version for VideoPlaylist feature
 * 
 * Only includes properties and methods actually used in VideoPlaylist context:
 * - id: Video identifier
 * - duration: Video duration in milliseconds
 * - thumbnail: Video thumbnail URL
 * - status: Video processing status
 * - skills: Array of SportSkill objects
 * - hasFailures: Check if video has failed processing
 */
export class Video {
  static fromGraphQL(data) {
    return new Video({
      id: data.id,
      duration: data.duration ?? data.defaultVideoCapture?.videoHost?.videoDuration,
      thumbnail: data.thumbnail ?? data.defaultVideoCapture?.videoHost?.videoThumbnail,
      status: data.status ? getVideoStatusViaString(data.status) : undefined,
      skills: data.metadata?.skills
        ? data.metadata.skills.map((id) => SportSkill.fromGraphQL({ id }))
        : [],
    });
  }

  _id;
  _duration;
  _thumbnail;
  _status;
  _skills = [];

  constructor({ id, duration, thumbnail, status, skills }) {
    this._id = id;
    this._duration = duration;
    this._thumbnail = thumbnail;
    this._status = status;
    this._skills = skills || [];
  }

  get id() {
    return this._id;
  }

  get duration() {
    return this._duration;
  }

  get thumbnail() {
    return this._thumbnail;
  }

  get status() {
    return this._status;
  }

  get skills() {
    return this._skills || [];
  }

  get hasFailures() {
    const statuses = [
      VideoStatus.UploadFailed,
      VideoStatus.Failed,
      VideoStatus.TranscodingFailed
    ];
    return statuses.includes(this.status);
  }
}
